export default "__VITE_ASSET__De1dxyYC__";